<template>
    <div
      ref="wrapper"
      class="dnd-wrapper"
      :style="variables"
    >
      <slot name="map"></slot>

      <div @mousedown.prevent="resizeStart($event, 'top')" class="control control-top"></div>
      <div @mousedown.prevent="resizeStart($event, 'right')" class="control control-right"></div>
      <div @mousedown.prevent="resizeStart($event, 'bottom')" class="control control-bottom"></div>
      <div @mousedown.prevent="resizeStart($event, 'left')" class="control control-left"></div>

      <div @mousedown.prevent="resizeStart($event, 'top', 'left')" class="control control-top-left"></div>
      <div @mousedown.prevent="resizeStart($event, 'top', 'right')" class="control control-top-right"></div>
      <div @mousedown.prevent="resizeStart($event, 'bottom', 'left')" class="control control-bottom-left"></div>
      <div @mousedown.prevent="resizeStart($event, 'bottom', 'right')" class="control control-bottom-right"></div>

      <div
        :class="{'control-mirror': isActive || !isTop}"
        @mousedown.prevent="resizeStart($event)"
      />
    </div>
  </template>
  
  <script>

  export default {
    name: 'c-custom-dnd',
    components: {
    },
    props: {
      w: {
        type: Number,
        default: 0
      },
      h: {
        type: Number,
        default: 0,
      },
      x: {
        type: Number,
        default: 0
      },
      y: {
        type: Number,
        default: 0
      },
      z: {
        type: Number,
        default: 0
      },
      minw: {
        type: Number,
        default: 0
      },
      minh: {
        type: Number,
        default: 0
      },
      isActive: {
        type: Boolean,
        default: false
      },
      isTop: {
        type: Boolean,
        default: false
      },
      rect: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data() {
      return {
      }
    },
    created() {
      this.deltaX = 0
      this.deltaY = 0
    
      this.a = null
      this.b = null

      this.draggable = false

      this.current = { ...this.rect }
    },
    mounted() {
      this.onMousemove = ({ clientX, clientY }) => {
        if (this.isActive) {
          let width = this.rect.width
          let height = this.rect.height
          let left = this.rect.left
          let top = this.rect.top

          const maxl = left + width - this.minw
          const maxt = top + height - this.minh

          let deltaSize = 0

          if (this.draggable) {
            left -= this.deltaX - clientX
            top -= this.deltaY - clientY
          } else {
            switch(this.a) {
              case 'top':
                deltaSize = this.deltaY - clientY
                height += deltaSize
                top -= deltaSize
                break
              case 'right':
                width += clientX - this.deltaX
                break
              case 'bottom':
                height += clientY - this.deltaY
                break
              case 'left':
                deltaSize = this.deltaX - clientX
                width += deltaSize
                left -= deltaSize
                break
            }

            switch(this.b) {
              case 'right':
                width += clientX - this.deltaX
                break
              case 'left':
                deltaSize = this.deltaX - clientX
                width += deltaSize
                left -= deltaSize
                break
            }

            if (width < this.minw) width = this.minw
            if (height < this.minh) height = this.minh
            if (left > maxl) left = maxl
            if (top > maxt) top = maxt
          }
          this.$refs.wrapper.style.width = `${width}px`
          this.$refs.wrapper.style.height = `${height}px`
          this.$refs.wrapper.style.top = `${top}px`
          this.$refs.wrapper.style.left = `${left}px`

          this.current = {width, height, top, left }
        }
      }

      this.onMouseup = () => this.rectDeactivate()

      window.addEventListener('mousemove', this.onMousemove)
      window.addEventListener('mouseup', this.rectDeactivate)

      this.onMousedownHeader = (e) => {
        this.deltaX = e.detail.clientX
        this.deltaY = e.detail.clientY
        this.draggable = true
      }
      window.addEventListener('custom_mousedown', this.onMousedownHeader)
    },
    beforeDestroy() {
      window.removeEventListener('mousemove', this.onMousemove)
      window.removeEventListener('mouseup', this.rectDeactivate)
      window.removeEventListener('custom_mousedown', this.onMousedownHeader)
    },
    computed: {
      variables() {
        return {
          '--width': `${this.w}px`,
          '--height': `${this.h}px`,
          '--left': `${this.x}px`,
          '--top': `${this.y}px`,
          '--z-index': this.z
        }
      }
    },
    methods: {
      resizeStart(event, a, b) {
        this.deltaX = event.clientX
        this.deltaY = event.clientY
        this.a = a
        this.b = b

        this.$emit('rectActivate', this.rect)
      },
      rectDeactivate() {
        this.deltaX = 0
        this.deltaY = 0
    
        this.a = null
        this.b = null
        this.draggable = false

        this.$emit('rectResize', { ...this.current }, this.rect)
        this.$emit('rectDeactivate')
      }
    }
  }
  </script>
  
  <style lang="scss">
    $size: 6px;
    $k: -1.1;


    .dnd {
      &-wrapper {
        position: absolute;
        width: var(--width);
        height: var(--height);
        left: var(--left);
        top: var(--top);
        z-index: var(--z-index);
        border: 1px solid;
      }
    }

    .control {
      // background-color: red;

      position: absolute;
      z-index: 3;

      &-top {
        left: 0;
        top: -$size;
      }

      &-bottom {
        left: 0;
        bottom: -$size;
      }

      &-bottom,
      &-top {
        width: 100%;
        height: $size;
        cursor: row-resize;
      }

      &-right {
        top: 0;
        right: -$size;
      }

      &-left {
        top: 0;
        left: -$size;
      }

      &-right,
      &-left {
        width: $size;
        height: 100%;
        cursor: col-resize;
      }

      &-top-left {
        top: $k * $size;
        left: $k * $size;
      }
      &-top-right {
        top: $k * $size;
        right: $k * $size;
      }
      &-bottom-left {
        bottom: $k * $size;
        left: $k * $size;
      }
      &-bottom-right {
        bottom: $k * $size;
        right: $k * $size;
      }

      &-top-left,
      &-top-right,
      &-bottom-left,
      &-bottom-right {
        width: $size * 2;
        height: $size * 2;
      }

      &-top-right,
      &-bottom-left {
        cursor: nesw-resize;
      }

      &-top-left,
      &-bottom-right {
        cursor: nwse-resize;
      }

      &-mirror {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.0);
        width: 100%;
        height: calc(100% - 36px);
        top: 36px;
        left: 0;
        z-index: 2;
      }
    }
  </style>